import { revokeServerSession } from "./serverSessionLogout";

function setCookie(name: string, value: string, days = 7) {
  if (typeof document === "undefined") return;
  const maxAge = days * 24 * 60 * 60;
  const isSecure = typeof location !== "undefined" && location.protocol === "https:";
  const secureAttr = isSecure ? "; secure" : "";
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; path=/; max-age=${maxAge}; samesite=lax${secureAttr}`;
}

function deleteCookie(name: string) {
  if (typeof document === "undefined") return;
  const isSecure = typeof location !== "undefined" && location.protocol === "https:";
  const secureAttr = isSecure ? "; secure" : "";
  document.cookie = `${name}=; path=/; max-age=0; samesite=lax${secureAttr}`;
}

export async function saveCustomerToken(token: string) {
  if (typeof window === "undefined") return;
  localStorage.setItem("customer_auth_token", token);

  try {
    await fetch("/api/customer-auth/set-cookie", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
  } catch {
    setCookie("customer_auth_token", token, 7);
  }
}

export function getCustomerToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem("customer_auth_token");
}

export async function clearCustomerToken(
  options: { expectedToken?: string; revokePushBindings?: boolean } = {}
) {
  if (typeof window === "undefined") return;
  const token = getCustomerToken();
  if (options.expectedToken !== undefined && token !== options.expectedToken) return;
  const revokePushBindings =
    options.revokePushBindings !== false && token
      ? import("./pushNotifications")
          .then(({ revokeCurrentCustomerPushBindings }) =>
            revokeCurrentCustomerPushBindings(token)
          )
          .catch(() => undefined)
      : Promise.resolve();
  localStorage.removeItem("customer_auth_token");
  deleteCookie("customer_auth_token");

  try {
    await Promise.allSettled([
      revokePushBindings,
      token ? revokeServerSession("/customer-auth/logout", token) : Promise.resolve(),
      fetch("/api/customer-auth/clear-cookie", { method: "POST" }),
    ]);
  } catch {
    /* noop */
  }
}
